import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { Router } from '@angular/router';

import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl
} from "@angular/forms";
import { parse } from 'querystring';
import { CartService } from '../../_services/cart.service';

@Component({
  selector: 'app-store-cart',
  templateUrl: './store-cart.component.html',
  styleUrls: ['./store-cart.component.css']
})
export class StoreCartComponent implements OnInit {
  public addItemForm: FormGroup;
  public storeProject: any = {};
  private activeProjIndex = 0;
  private activeProdIndex = 0;
  public subTotal = 0;
  public prodData: any = {};
  totalCartProduct=0;
  public SelectProductData: any = [
  ];
  public totalQty = 0;
  constructor(private formBuilder: FormBuilder,
    private CommonProjectDataService: CommonProjectDataService,
    private router: Router,
    private cartService: CartService

  ) { }

  ngOnInit() {
    this.addItemForm = this.formBuilder.group({
      size: [null, Validators.required]
    });
    //this.storeProject = JSON.parse(JSON.stringify(this.CommonProjectDataService.getQuoteData()));
    //this.activeProjIndex = this.CommonProjectDataService.getActiveProject();
    //this.activeProdIndex = this.CommonProjectDataService.getActiveProductIndex();
    this.storeProject = JSON.parse(localStorage.getItem("storeData"));
    this.totalCartProduct=localStorage.getItem("totalCartProduct")?parseInt(localStorage.getItem("totalCartProduct")):0;
    //this.activeProjIndex=parseInt(localStorage.getItem("projIndex"));
    //this.activeProdIndex=parseInt(localStorage.getItem("productIndex"));
    //this.prodData = this.storeProject.projects_data[this.activeProjIndex].products[this.activeProdIndex];
    //this.SelectProductData = this.CommonProjectDataService.getSelectProductData();
    this.SelectProductData = localStorage.getItem("SelectProductData") ? JSON.parse(localStorage.getItem("SelectProductData")) : [];
    //this.subTotal=this.CommonProjectDataService.getSubTotalPrice();
    //this.totalQty=this.CommonProjectDataService.getCartTotalQty();
    this.subTotal = localStorage.getItem("totalPrice") ? Number(localStorage.getItem("totalPrice")) : 0;
    this.totalQty = localStorage.getItem("totalQty") ? parseInt(localStorage.getItem("totalQty")) : 0;   
  }

  trackByFn(index: any, item: any) {
    return index;
  }

  showCheckout() {
    this.router.navigate(["store/cutomer-detail"]);
  }
  removeCartItem(prodIndex, sizeIndex, price, qty) {    
    if (this.SelectProductData[prodIndex].product[0].size.length > 1) {
      this.SelectProductData[prodIndex].product[0].size.splice(sizeIndex, 1);
      this.SelectProductData[prodIndex].product[0].quantity.splice(sizeIndex, 1);
    }
    else {
     this.SelectProductData.splice(prodIndex,1);
    }
    this.subTotal = this.subTotal - (price * parseInt(qty));
    this.totalQty = this.totalQty - parseInt(qty);
    this.totalCartProduct -=1;
    this.cartService.setCartQuantity(this.totalCartProduct);
    localStorage.setItem("SelectProductData", JSON.stringify(this.SelectProductData));
    localStorage.setItem("totalQty",this.totalQty.toString());
    localStorage.setItem("totalPrice",this.subTotal.toString()); 
    localStorage.setItem("totalCartProduct",this.totalCartProduct.toString()); 

  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-store-product/store-cart/store-cart.component.ts